var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.chRels)?_c('a',{on:{"click":function($event){return _vm.openRels( 'CHILD' )}}},[_vm._v(_vm._s(_vm.chRels)+" direct")]):_vm._e(),(_vm.chRels && _vm.prRels)?_c('span',[_vm._v(", ")]):_vm._e(),(_vm.prRels)?_c('a',{on:{"click":function($event){return _vm.openRels( 'PARENT' )}}},[_vm._v(_vm._s(_vm.prRels)+" backward")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }